export default "---\nname: Smart ammo\ncount: 1\n# owner: HORSE                 # optional: callsign of the pilot holding it\n---\n"